export default "__VITE_ASSET__BWYL7VaJ__"